import * as React from "react";
import {
    List,
    TextInput,
    Datagrid,
    TextField,
    Filter,
    SimpleList,
    useLocale,
    ReferenceField,
} from "react-admin";

import { useMediaQuery } from "@material-ui/core";
import { Cancel, CheckCircle } from "@material-ui/icons";

export const UserGroupList = (props) => {
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const locale = useLocale();

    const GroupFilter = (props) => (
        <Filter {...props}>
            <TextInput label="Search by name" source="name" alwaysOn />
        </Filter>
    );

    return (
        <List
            style={{ marginTop: -5, marginLeft: -10, marginRight: -10 }}
            {...props}
            perPage={100}
            sort={{ field: "name", order: "DESC" }}
            filters={<GroupFilter />}
        >
            {isSmall ? (
                <SimpleList
                    linkType="show"
                    primaryText={(record) => record.name}
                    secondaryText={(record) => `${record.id}`}
                    tertiaryText={(record) =>
                        record.active ? <CheckCircle /> : <Cancel />
                    }
                />
            ) : (
                <Datagrid locales={locale} rowClick="show">
                    <ReferenceField
                        link={"show"}
                        source="organisation_id"
                        reference="organisation"
                    >
                        <TextField source={"name"} />
                    </ReferenceField>
                    <TextField source={"name"} />
                </Datagrid>
            )}
        </List>
    );
};
